"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataChooser = void 0;
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const react_1 = __importStar(require("react"));
const DataChooserPopover_1 = __importDefault(require("./DataChooserPopover"));
const DataChooserValueList_1 = __importDefault(require("./DataChooserValueList"));
function DataChooser(props) {
    const { classes, value = [], items, ignoredItems = [], allowedItems = [], onChange, onAddNew, addLabel, noBorder = false, multi = false, disabled = false, alwaysWrap = false, type, filters, selectLabel, allSelectable = false, allSelected = false, allSelectedLabel = lib_i18n_1.default.t('all'), onSelectAll, required = false, showTotals, } = props;
    const [open, setOpen] = (0, react_1.useState)(false);
    const buttonRef = (0, react_1.useRef)();
    const handleClickValueList = (0, react_1.useCallback)(e => {
        e.stopPropagation();
        if (!disabled)
            setOpen(true);
    }, [disabled]);
    const handleClose = (0, react_1.useCallback)(() => setOpen(false), []);
    const handleClickSelectAll = (0, react_1.useCallback)(onOff => {
        if (!required || onOff)
            onSelectAll(onOff);
        if (!multi)
            setOpen(false);
    }, [required, onSelectAll, multi]);
    const handleRemoveAllSelected = (0, react_1.useCallback)(() => onSelectAll(false), [onSelectAll]);
    const handleChange = (0, react_1.useCallback)(v => {
        // setSelectedItems(v)
        onChange === null || onChange === void 0 ? void 0 : onChange(v);
        if (!multi)
            setOpen(false);
    }, [multi, onChange]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(DataChooserValueList_1.default, { classes: classes, ref: buttonRef, disabled: disabled, alwaysWrap: alwaysWrap, noBorder: noBorder, required: required, selectLabel: selectLabel, type: (type === null || type === void 0 ? void 0 : type.length) === 1 ? type[0] : undefined, allSelectable: allSelectable, allSelected: multi && allSelected, allSelectedLabel: allSelectedLabel, onRemoveAllSelected: handleRemoveAllSelected, value: value, onChange: handleChange, onClick: handleClickValueList }),
        open && (react_1.default.createElement(DataChooserPopover_1.default, { open: true, onClose: handleClose, anchorEl: buttonRef.current, multi: multi, items: items, ignoredItems: ignoredItems, allowedItems: allowedItems, type: type, value: value, onChange: handleChange, filters: filters, addLabel: addLabel, onAddNew: onAddNew, allSelectable: allSelectable, allSelected: multi && allSelected, allSelectedLabel: allSelectedLabel, onSelectAll: onSelectAll ? handleClickSelectAll : undefined, showTotals: showTotals }))));
}
exports.DataChooser = DataChooser;
exports.default = DataChooser;
